import type { FaireProductEntity } from "../../entity_types/product";

export const p_ujdwjnqeg5: FaireProductEntity = {
  token: "p_ujdwjnqeg5",
  type: "product",
  name: "Mini Hearts Blush Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/66d5fe71e20b22091d0f6478c97f78808b247369b81a8ef28d94de125953a223.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fbc83a6dae42b362f208f1b663552c7e8b1c627e014e66244456fe55a775e811.jpeg",
    "https://cdn.faire.com/fastly/d936777b62d25b0dfb0e640d1ed7cb3a7a7ae95fe3bd656776ae5c3bdd7ed091.jpeg",
  ],
  priceDollars: 8,
  description:
    'A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be "well-edited" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:42.314Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
